import React, { useState } from 'react';
import DOMPurify from 'dompurify';
import { useNavigate } from 'react-router-dom';

import {
    checkFields,
    checkInvalidDateNaissance,
    checkInvalidNom,
    renderError,
    upperCaseRemoveAccent
} from 'utils/formUtils';
import { v4 as uuidv4 } from 'uuid';

import SecondaryNavBar from 'Components/SecondaryNavBar/SecondaryNavBar';
import LoadingOverlay from 'Components/LoadingOverlay/LoadingOverlay';

import { displayValOrNc, getLabelInput } from 'utils/stringUtils';

import './RecherchePersonne.scss';
import Pagination from '../../../Components/Pagination/Pagination';
import {
    getRecherchePersonneByNomPRenomDateNaissance,
    getRecherchePersonneByNumAgent,
    getRecherchePersonneByNumContrat, getRechercheProspect
} from "../../../api/recherchePersonneService";
import { useDispatch, useSelector } from "react-redux";
import {
    clearGestionContrat,
    clearTablePersonne,
    updateIdPersGrc,
    updateTablePersonne
} from "../../../Redux/gestionContrat/gestionContratReducer";
import PaginationWithTable from "../../../Components/PaginationWithTable/PaginationWithTable";

export default function RecherchePersonne() {

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const {
        tablePersonne,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
    }))

    const CONF = window?.confPub;
    const UI = CONF?.UI?.RECHERCHE_PERSONNE;
    const INPUTS = UI?.INPUTS;
    const ROUTES = CONF.ROUTES;
    const PAGES = ROUTES.PAGES;
    const REGEX = CONF?.UI.REGEX;

    const [submitted, setSubmitted] = useState(false);
    const [disabledForm, setDisableForm] = useState(false);
    const [activeFieldset, setActiveFieldset] = useState(UI?.FIELDSET_NAME?.NUM_CONTRAT);
    const [displayRecherche, setDisplayRecherche] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isAdherentTable, setIsAdherentTable] = useState(true);
    const [noResultFound, setNoResultFound] = useState(false);

    const initAdherent = () => {

        return {
            numContrat: {
                value: '',
                invalid: INPUTS?.NUM_CONTRAT?.ERRORS?.MANDATORY,
            },
            numAgent: {
                value: '',
                invalid: INPUTS?.NUM_AGENT?.ERRORS?.MANDATORY,
            },
            nom: {
                value: '',
                invalid: INPUTS?.NOM?.ERRORS?.MANDATORY,
            },
            prenom: {
                value: '',
                invalid: INPUTS?.PRENOM?.ERRORS?.MANDATORY,
            },
            dateNaissance: {
                value: '',
                invalid: false,
            },
            [UI?.INPUTS?.RECHERCHE_ETENDUE?.NAME]: {
                value: false,
                invalid: false,
            }
        }
    }

    const [personne, setPersonne] = useState(initAdherent());

    const handleRadio = (e) => {

        setSubmitted(false);
        const radioValue = e.target.value;

        setActiveFieldset(radioValue);

        setPersonne(initAdherent());
    }

    const handleInput = (e) => {

        const { name, value, type, checked } = e?.target

        const valueUpdated = type === 'text' ? upperCaseRemoveAccent(value) : value

        const { invalid } = checkFields(name, valueUpdated);

        const newPersonne = {
            ...personne,
            [name]: {
                value: type === "checkbox" ? checked : valueUpdated,
                invalid: invalid,
            }
        }

        setPersonne(newPersonne);
    }

    const handleSubmit = async (e) => {

        // TODO pouruqoi on check sur le target et on envoi personne ??
        e.preventDefault();
        setSubmitted(true);
        setDisableForm(true);

        const target = e?.target

        setIsAdherentTable(activeFieldset !== UI?.FIELDSET_NAME?.PROSPECT);
        let invalidForm = false;

        if (activeFieldset === UI?.FIELDSET_NAME?.NUM_CONTRAT) {

            const value = target[INPUTS.NUM_CONTRAT.NAME].value.trim();
            const { invalid } = checkFields(INPUTS.NUM_CONTRAT.NAME, value);

            invalidForm = invalid;

        } else if (activeFieldset === UI?.FIELDSET_NAME?.NUM_AGENT) {

            const value = target[INPUTS.NUM_AGENT.NAME].value.trim();
            const { invalid } = checkFields(INPUTS.NUM_AGENT.NAME, value);

            invalidForm = invalid;


        } else if (activeFieldset === UI?.FIELDSET_NAME?.ADHERENT || activeFieldset === UI?.FIELDSET_NAME?.PROSPECT) {

            const nomValue = target[INPUTS.NOM.NAME].value.trim();
            const prenomValue = target[INPUTS.PRENOM.NAME].value.trim();
            const dateNaissanceValue = target[INPUTS.DATE_NAISSANCE.NAME].value.trim();

            const { invalid: invalidNom } = checkFields(INPUTS.NOM.NAME, nomValue);
            const { invalid: invalidPrenom } = checkFields(INPUTS.PRENOM.NAME, prenomValue);
            const { invalid: invalidDateNaissance } = checkFields(INPUTS.DATE_NAISSANCE.NAME, dateNaissanceValue);

            invalidForm = invalidNom || invalidPrenom || invalidDateNaissance;
        }

        if (!invalidForm) {

            dispatch(clearGestionContrat())
            let res = false

            try {

                if (activeFieldset === UI?.FIELDSET_NAME?.NUM_CONTRAT) {

                    res = await getRecherchePersonneByNumContrat(personne?.numContrat?.value.trim())

                } else if (activeFieldset === UI?.FIELDSET_NAME?.NUM_AGENT) {

                    res = await getRecherchePersonneByNumAgent(personne?.numAgent?.value.trim())


                } else if (activeFieldset === UI?.FIELDSET_NAME?.ADHERENT) {

                    res = await getRecherchePersonneByNomPRenomDateNaissance(
                        personne?.nom?.value.trim(),
                        personne?.prenom?.value.trim(),
                        personne?.dateNaissance?.value,
                        personne?.[INPUTS?.RECHERCHE_ETENDUE?.NAME]?.value
                    )

                } else if (activeFieldset === UI?.FIELDSET_NAME?.PROSPECT) {

                    res = await getRechercheProspect(
                        personne?.nom?.value.trim(),
                        personne?.prenom?.value.trim(),
                        personne?.dateNaissance?.value,
                        personne?.[INPUTS?.RECHERCHE_ETENDUE?.NAME]?.value
                    )
                }

                console.log("res")
                console.log(res)

                if (res?.status === 404) {
                    // fixme fonctionne pas comme je veux

                    setNoResultFound(res?.data);

                } else {

                    setNoResultFound(false);

                    if (Array.isArray(res.data)) {

                        dispatch(updateTablePersonne(res.data))

                        if (res.data.length === 0) {
                            setNoResultFound("Pas de résultats pour cette recherche.");
                        }

                    } else {
                        console.log("else ta mère")

                        setNoResultFound("Pas de résultats pour cette recherche.");
                    }
                }
            } catch (err) {

                console.log('err', err)
                dispatch(clearTablePersonne())
                setNoResultFound("Pas de résultats pour cette recherche.");
            } finally {

                setDisableForm(false);
            }

        } else {

            console.log("pas valide")
            setDisableForm(false);
        }

    }

    const effacerRecherche = () => {

        setPersonne(initAdherent);
        dispatch(clearGestionContrat())
        setSubmitted(false);
        setNoResultFound(false);
    }

    const versFichePersonne = (idPersGrc) => {

        dispatch(updateIdPersGrc(idPersGrc))

        navigate(PAGES.FICHE_PERSONNE);
    }

    const BuildResultatsTable = ({ data: tablePersonne }) => {

        return (
            <div className='table-responsive-lg'>
                <table className="table">
                    <thead>
                    <tr>
                        { isAdherentTable && (
                            <>
                                <th>Numéro contrat</th>
                                <th>N°Agent</th>
                            </>
                        ) }
                        <th>Nom</th>
                        <th>Prénom</th>
                        <th>Date de naissance</th>
                        <th>Email</th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody>

                    { tablePersonne?.length > 0 && tablePersonne.map(personne => {
                        return (
                            // eslint-disable-next-line react/jsx-key
                            <tr key={ uuidv4() }>
                                { isAdherentTable && (
                                    <>
                                        <td>{ personne?.contrat?.[0]?.numeroContrat }</td>
                                        <td>{ displayValOrNc(personne?.numeroAgent) }</td>
                                    </>
                                ) }
                                <td>{ personne?.nom }</td>
                                <td>{ personne?.prenom }</td>
                                <td>{ personne?.dateNaissance }</td>
                                <td>{ displayValOrNc(personne?.email) }</td>
                                <td>
                                    { isAdherentTable ? (
                                        <button
                                            onClick={ () => versFichePersonne(personne?.idPersGrc) }
                                            className="btn btn-primary">
                                            Voir&nbsp;le&nbsp;profil
                                        </button>
                                    ) : (
                                        <div>
                                            -
                                            {/*<button*/ }
                                            {/*    className="btn btn-primary"*/ }
                                            {/*    disabled={ true }*/ }
                                            {/*>*/ }
                                            {/*    Créer un devis*/ }
                                            {/*    pour { personne?.prenom } { personne?.nom }*/ }
                                            {/*</button>*/ }
                                        </div>
                                    ) }
                                </td>
                            </tr>
                        )
                    }) }

                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <div className='container rechercher-personne-container mt-3'>

            <SecondaryNavBar activePage='recherche'/>

            <main id='content' className='overlay-container'>

                { disabledForm && <LoadingOverlay classes="upload-overlay"/> }

                <div className="card">

                    <div className="card-header">
                        <h1 className="my-2">Recherche Personne</h1>
                    </div>

                    <div className="card-body">
                        <form onSubmit={ handleSubmit }>

                            <fieldset>

                                {/*########################################################*/ }
                                {/*#################### RADIOS ############################*/ }
                                {/*########################################################*/ }

                                <legend>Recherche par :</legend>

                                <div className="mb-3">
                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name={ INPUTS?.FORM_RADIO.NAME }
                                            id={ INPUTS?.FORM_RADIO?.OPTIONS?.NUM_CONTRAT?.ID }
                                            onChange={ handleRadio }
                                            value={ INPUTS?.FORM_RADIO?.OPTIONS?.NUM_CONTRAT?.VALUE }
                                            defaultChecked
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor={ INPUTS?.FORM_RADIO?.OPTIONS?.NUM_CONTRAT?.ID }>
                                            { INPUTS?.FORM_RADIO?.OPTIONS?.NUM_CONTRAT?.LABEL }
                                        </label>
                                    </div>

                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name={ INPUTS?.FORM_RADIO.NAME }
                                            id={ INPUTS?.FORM_RADIO?.OPTIONS?.NUM_AGENT?.ID }
                                            onChange={ handleRadio }
                                            value={ INPUTS?.FORM_RADIO?.OPTIONS?.NUM_AGENT?.VALUE }
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor={ INPUTS?.FORM_RADIO?.OPTIONS?.NUM_AGENT?.ID }>
                                            { INPUTS?.FORM_RADIO?.OPTIONS?.NUM_AGENT?.LABEL }
                                        </label>
                                    </div>

                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name={ INPUTS?.FORM_RADIO.NAME }
                                            id={ INPUTS?.FORM_RADIO?.OPTIONS?.ADHERENT?.ID }
                                            onChange={ handleRadio }
                                            value={ INPUTS?.FORM_RADIO?.OPTIONS?.ADHERENT?.VALUE }
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor={ INPUTS?.FORM_RADIO?.OPTIONS?.ADHERENT?.ID }>
                                            { INPUTS?.FORM_RADIO?.OPTIONS?.ADHERENT?.LABEL }
                                        </label>
                                    </div>

                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name={ INPUTS?.FORM_RADIO.NAME }
                                            id={ INPUTS?.FORM_RADIO?.OPTIONS?.PROSPECT?.ID }
                                            onChange={ handleRadio }
                                            value={ INPUTS?.FORM_RADIO?.OPTIONS?.PROSPECT?.VALUE }
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor={ INPUTS?.FORM_RADIO?.OPTIONS?.PROSPECT?.ID }>
                                            { INPUTS?.FORM_RADIO?.OPTIONS?.PROSPECT?.LABEL }
                                        </label>
                                    </div>
                                </div>

                                {/*########################################################*/ }
                                {/*#################### RECHERCHE #########################*/ }
                                {/*########################################################*/ }

                                <div className="row">
                                    <div className="col-lg-12">
                                        <fieldset>
                                            <div className="row justify-content-between">

                                                { activeFieldset === INPUTS?.FORM_RADIO?.OPTIONS?.NUM_CONTRAT?.VALUE &&
                                                    <>
                                                        <div className='col-lg-4 mb-3'>
                                                            <label
                                                                htmlFor={ UI?.INPUTS?.NUM_CONTRAT?.NAME }
                                                                className='form-label'
                                                                dangerouslySetInnerHTML={ {
                                                                    __html: DOMPurify.sanitize(getLabelInput(UI?.INPUTS?.NUM_CONTRAT))
                                                                } }/>
                                                            <input
                                                                name={ UI?.INPUTS?.NUM_CONTRAT?.NAME }
                                                                className={ `form-control ${ submitted
                                                                && personne?.numContrat?.invalid && 'is-invalid' }` }
                                                                onChange={ handleInput }
                                                                value={ personne?.numContrat?.value }
                                                                placeholder={ UI?.INPUTS?.NUM_CONTRAT?.PLACEHOLDER }
                                                                type="text"/>

                                                            { submitted && personne?.numContrat?.invalid && renderError(personne?.numContrat?.invalid) }
                                                        </div>
                                                    </>
                                                }

                                                { activeFieldset === INPUTS?.FORM_RADIO?.OPTIONS?.NUM_AGENT?.VALUE &&
                                                    <>
                                                        <div className='col-lg-4 mb-3'>
                                                            <label
                                                                htmlFor={ UI?.INPUTS?.NUM_AGENT?.NAME }
                                                                className='form-label'
                                                                dangerouslySetInnerHTML={ {
                                                                    __html: DOMPurify.sanitize(getLabelInput(UI?.INPUTS?.NUM_AGENT))
                                                                } }/>
                                                            <input
                                                                name={ UI?.INPUTS?.NUM_AGENT?.NAME }
                                                                className={ `form-control ${ submitted
                                                                && personne?.numAgent?.invalid && 'is-invalid' }` }
                                                                onChange={ handleInput }
                                                                value={ personne?.numAgent?.value }
                                                                placeholder={ UI?.INPUTS?.NUM_AGENT?.PLACEHOLDER }
                                                                type="text"/>

                                                            { submitted && personne?.numAgent?.invalid && renderError(personne?.numAgent?.invalid) }
                                                        </div>
                                                    </>
                                                }

                                                { (activeFieldset === INPUTS?.FORM_RADIO?.OPTIONS?.ADHERENT?.VALUE || activeFieldset === INPUTS?.FORM_RADIO?.OPTIONS?.PROSPECT?.VALUE) &&
                                                    <>
                                                        <div className='col-lg-4 mb-3'>
                                                            <label
                                                                htmlFor={ UI?.INPUTS?.NOM?.NAME }
                                                                className='form-label'
                                                                dangerouslySetInnerHTML={ {
                                                                    __html: DOMPurify.sanitize(getLabelInput(UI?.INPUTS?.NOM))
                                                                } }/>
                                                            <input
                                                                name={ UI?.INPUTS?.NOM?.NAME }
                                                                className={ `form-control ${ submitted
                                                                && personne?.nom?.invalid && 'is-invalid' }` }
                                                                onChange={ handleInput }
                                                                value={ personne?.nom?.value }
                                                                placeholder={ UI?.INPUTS?.NOM?.PLACEHOLDER }
                                                                type="text"/>

                                                            { submitted && personne?.nom?.invalid && renderError(personne?.nom?.invalid) }
                                                        </div>

                                                        <div className='col-lg-4 mb-3'>
                                                            <label
                                                                htmlFor={ UI?.INPUTS?.PRENOM?.NAME }
                                                                className='form-label'
                                                                dangerouslySetInnerHTML={ {
                                                                    __html: DOMPurify.sanitize(getLabelInput(UI?.INPUTS?.PRENOM))
                                                                } }/>
                                                            <input
                                                                name={ UI?.INPUTS?.PRENOM?.NAME }
                                                                className={ `form-control ${ submitted
                                                                && personne?.prenom?.invalid && 'is-invalid' }` }
                                                                onChange={ handleInput }
                                                                value={ personne?.prenom?.value }
                                                                placeholder={ UI?.INPUTS?.PRENOM?.PLACEHOLDER }
                                                                type="text"/>

                                                            { submitted && personne?.prenom?.invalid && renderError(personne?.prenom?.invalid) }
                                                        </div>

                                                        <div className='col-lg-4 mb-3'>
                                                            <label
                                                                htmlFor={ UI?.INPUTS?.DATE_NAISSANCE?.NAME }
                                                                className='form-label'
                                                                dangerouslySetInnerHTML={ {
                                                                    __html: DOMPurify.sanitize(getLabelInput(UI?.INPUTS?.DATE_NAISSANCE, true))
                                                                } }/>
                                                            <input
                                                                name={ UI?.INPUTS?.DATE_NAISSANCE?.NAME }
                                                                className={ `form-control ${ submitted &&
                                                                personne?.dateNaissance?.invalid && 'is-invalid' }` }
                                                                onChange={ handleInput }
                                                                value={ personne?.dateNaissance?.value }
                                                                type="date"/>
                                                            { submitted && personne?.dateNaissance?.invalid && renderError(personne?.dateNaissance?.invalid) }
                                                        </div>
                                                    </>
                                                }

                                                <div className={ `${ (activeFieldset === INPUTS?.FORM_RADIO?.OPTIONS?.ADHERENT?.VALUE 
                                                    || activeFieldset === INPUTS?.FORM_RADIO?.OPTIONS?.PROSPECT?.VALUE) ? 'col-12' : 'col-4' } d-flex justify-content-between` }>
                                                    { (activeFieldset === INPUTS?.FORM_RADIO?.OPTIONS?.ADHERENT?.VALUE
                                                        || activeFieldset === INPUTS?.FORM_RADIO?.OPTIONS?.PROSPECT?.VALUE) && (
                                                        <div className="form-check form-switch">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                name={ UI?.INPUTS?.RECHERCHE_ETENDUE?.NAME }
                                                                id={ UI?.INPUTS?.RECHERCHE_ETENDUE?.NAME }
                                                                onChange={ handleInput }
                                                                checked={ personne?.[UI?.INPUTS?.RECHERCHE_ETENDUE?.NAME]?.value || "" }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={ UI?.INPUTS?.RECHERCHE_ETENDUE?.NAME }
                                                            >
                                                                { UI?.INPUTS?.RECHERCHE_ETENDUE?.LABEL }
                                                            </label>
                                                        </div>
                                                    ) }

                                                    <div className={ `d-flex justify-content-end ${ (activeFieldset === INPUTS?.FORM_RADIO?.OPTIONS?.ADHERENT?.VALUE
                                                        || activeFieldset === INPUTS?.FORM_RADIO?.OPTIONS?.PROSPECT?.VALUE) ? '' : 'align-baseline py-4' }` }>
                                                        <button type='submit' className="btn btn-primary">
                                                            Rechercher
                                                        </button>

                                                        <button type='button' className="btn btn-secondary ms-2"
                                                                onClick={ effacerRecherche }>
                                                            Effacer
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </fieldset>
                        </form>

                        {/*########################################################*/ }
                        {/*#################### RESULTATS #########################*/ }
                        {/*########################################################*/ }

                        <section id='resultats' className='mt-3'>

                            { noResultFound !== false && (
                                <div className='d-flex justify-content-center'>
                                    <p>{ noResultFound }</p>
                                </div>
                            ) }

                            { tablePersonne?.length > 0 && (
                                <PaginationWithTable
                                    records={ tablePersonne }
                                    recordsPerPage={ 10 }
                                    TableComponent={ BuildResultatsTable }
                                />
                            ) }
                        </section>
                    </div>
                </div>
            </main>
        </div>
    )
}